import { registerTheme } from '../../theme';
import { DEFAULT_AREA_THEME } from '../area/theme';

registerTheme('stackedArea', DEFAULT_AREA_THEME);
